export const DESKTOP_SLIDER_INDENTS = {
  left: 42,
  right: 42,
  between: 16,
  // отступ для тултипа позиции
  top: 60,
  // отступ для тени карточек
  bottom: 16,
};

export const DESKTOP_SLIDER_WITH_BET_POSITION_INDENTS = {
  ...DESKTOP_SLIDER_INDENTS,
  top: 0,
};

export const MOBILE_SLIDER_INDENTS = {
  left: 16,
  right: 16,
  between: 16,
  // отступ для тени карточек
  bottom: 16,
};
